/**
 * SVG path builders for rounded bar shapes.
 *
 * Pure functions — no React dependency. Used by RoundedBarShape components
 * and by custom bar renderers like DiagonalBar.
 */

/** Default corner radius for rounded bar shapes. */
export const BAR_CORNER_RADIUS = 4;

/** SVG path for a rect with rounded top-left and top-right corners. */
export const roundedTopRect = (x: number, y: number, w: number, h: number, r: number): string => {
    const cr = Math.min(r, w / 2, h);
    return [
        `M${x},${y + h}`,
        `V${y + cr}`,
        `Q${x},${y} ${x + cr},${y}`,
        `H${x + w - cr}`,
        `Q${x + w},${y} ${x + w},${y + cr}`,
        `V${y + h}`,
        `Z`,
    ].join(" ");
};

/** SVG path for a rect with rounded top-right and bottom-right corners (horizontal bars). */
export const roundedRightRect = (x: number, y: number, w: number, h: number, r: number): string => {
    const cr = Math.min(r, h / 2, w);
    return [
        `M${x},${y}`,
        `H${x + w - cr}`,
        `Q${x + w},${y} ${x + w},${y + cr}`,
        `V${y + h - cr}`,
        `Q${x + w},${y + h} ${x + w - cr},${y + h}`,
        `H${x}`,
        `Z`,
    ].join(" ");
};
